import axios from 'axios';
import { AppointmentController } from 'api';

const getCoopAppointmentById = async (id?: string) => {
  if (!id) {
    throw new Error('A showing id is required to fetch a showing');
  }

  const data = await AppointmentController.getAppointmentByIdForCoop(id);

  return data;
};

const getServerDate = async () => {
  const { data: serverDateString } = await axios.get<{ date: string }>('/date');

  return new Date(serverDateString.date);
};

export { getCoopAppointmentById, getServerDate };
